<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-top: -3px">
              <h3 class="text-white">Reset password</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <form role="form" @submit.prevent="handleSubmit()">
        <card class="card-login card-plain">
          <div>
            <fg-input
              v-model="email"
              @keyup.native="validateEmail()"
              class="no-border form-control-lg set-width"
              :placeholder="this.locale.email"
              addon-left-icon="now-ui-icons ui-1_email-85"
              :error="apiValidationErrors.email"
            >
            </fg-input>
            <div class="pull-left">
              <h6>
                <a class="link footer-link" href="/password/reset">
                  {{ this.locale.get_back }}
                </a>
              </h6>
            </div>
          </div>
          <br>
          <br>
            <n-button
                :class="{disabled: !login}"
                native-type="submit" type="primary" round block style="margin-left: 0">
              Send Password Reset Link
            </n-button>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
const url = process.env.VUE_APP_API_BASE_URL;
export default {
  mixins: [formMixin],
  data() {
    return {
      email: '',
      login: '',
      locale: '',
      users: [],
    };
  },

  methods: {
    validateEmail() {
      let user = this.users.filter(elem => elem.email == this.email);
      if (user && user[0])
        this.login = user[0].login;
    },

    async handleSubmit() {
      await this.$store.dispatch(
          "alerts/success",
          this.locale.check_spam
      );
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({email: this.email, login: this.login})
      };
      fetch(url + '/password-forgot', requestOptions)
          .then(async response => {
            const data = await response.json();
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }
          });
    },

    async getWorkers() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-workers-register', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            data.forEach(elem => {
              if (elem.employment_number)
              {
                if (elem.employment_number.toString().length === 1)
                  elem.employment_number = ('0' + elem.employment_number).slice(-3);
                if (elem.employment_number.toString().length === 2)
                  elem.employment_number = ('00' + elem.employment_number).slice(-3);
              }
              this.users.push(elem);
            })
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },
  },

  mounted() {
    this.locale = this.$getLocale();
    this.getWorkers();
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.set-width {
  width: 450px;
}

a.footer-link:hover {
  text-decoration: underline;
  text-decoration-color: #f96332;
  text-decoration-thickness: 2px;
}
</style>
